var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoChainOfCustody(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5V5.5C12 5.76522 12.1054 6.01957 12.2929 6.20711C12.4804 6.39464 12.7348 6.5 13 6.5H17M12 1.5H5C4.46957 1.5 3.96086 1.71071 3.58579 2.08579C3.21071 2.46086 3 2.96957 3 3.5V6.5M12 1.5L17 6.5M17 6.5V17.5C17 18.0304 16.7893 18.5391 16.4142 18.9142C16.0391 19.2893 15.5304 19.5 15 19.5H10M2.5 15.5L1 20.5L4 19L7 20.5L5.5 15.5M1 12.5C1 13.2956 1.31607 14.0587 1.87868 14.6213C2.44129 15.1839 3.20435 15.5 4 15.5C4.79565 15.5 5.55871 15.1839 6.12132 14.6213C6.68393 14.0587 7 13.2956 7 12.5C7 11.7044 6.68393 10.9413 6.12132 10.3787C5.55871 9.81607 4.79565 9.5 4 9.5C3.20435 9.5 2.44129 9.81607 1.87868 10.3787C1.31607 10.9413 1 11.7044 1 12.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoChainOfCustody);
export default __webpack_public_path__ + "static/media/no_chain_of_custody.60bb7c06bbddf16fc29c14529f3cef94.svg";
export { ForwardRef as ReactComponent };